<!-- GRID -->
<div class="tg-cnt-ext" #hScroll>
    <!-- GRID HEADER -->
    <div class="tg-header tgodata-header" *ngIf="isLoaded && !anyGridError">
        <div>
            <div class="tg-row-od bg-header">
                <div class="tg-sticky-container">
                    <div *ngIf="selectable" class="tg-ckb">
                        <input *ngIf="multiSelection" type="checkbox" class="tg-ckb-input"
                            (click)="onCheckAllRowsClick()">
                    </div>
                    <div *ngFor="let cCol of customIcoColsStart" class="tg-custom-ico-cell">
                        <!-- <span class="tg-header-text">{{cCol.header}}</span> -->
                    </div>
                    <div *ngFor="let cCol of calculatedColsStart" class="tg-custom-ico-cell">
                        <span class="tg-header-text">{{cCol.header}}</span>
                    </div>
                </div>
                <!-- [style.width.%]="cellWidthPerc!" -->
                <div *ngFor="let col of columnsGOD; let c=index; trackBy: trackByIndex" class="tg-cell tg-header-cell"
                    [class.sticky-column]="isSticky(c)" [style.left.px]="getStickyLeftPosition(c)" resizableColumn
                    [resizableColumnRedistribute]="resizableColumnRedistribute" [columnName]="col.name!"
                    [style.width.px]="col.width" [shouldRecalculate]="recalculateColumnsWidth"
                    [gridConfiguration]="gridConfiguration" [resizingFlag]="resizingFlag"
                    (onColumnWidthUpdate)="onColumnWidthUpdate($event)" [ngClass]="{'tg-header-sortable' : sortable, 'tg-cell-notvisible': col.visible == false, 'tg-cell-big': isCellBig(col.name!), 
                }" (click)="onSortClick(col.name!, col.visible!)"
                    [id]="'col_header_' + col.name!+ '_' + gridConfiguration.name"
                    (onResizeEnd)="onColumnSizeCalculationEnd()">
                    <div *ngIf="col.visible == true" class="tg-cell-visible tg-header-text">
                        <span class="tg-header-text">{{'grid.' + getColNameForTranslation(col.name!) |
                            translate}}</span>
                        <span class="tg-sort-ico" [innerHtml]="getSortIcon(col.name!)"></span>
                    </div>
                </div>
                <div *ngFor="let cCol of calculatedColsEnd" class="tg-custom-ico-cell">
                    <span class="tg-header-text">{{cCol.header}}</span>
                </div>
                <div *ngFor="let cCol of customIcoColsEnd" class="tg-custom-ico-cell">
                    <!--  <span class="tg-header-text">{{cCol.tooltip}}</span> -->
                </div>
                <div *ngIf="showEditIcon || showDeleteIcon" class="tg-custom-ico-cell">

                </div>
            </div>
            <!-- FILTERS -->
            <div class="tg-filter" [ngClass]="{'hide-filter' : !filterable}"> <!-- *ngIf="filterable" -->
                <div class="tg-row-od" style="height: 8vh;padding-bottom: 1vh;">
                    <div class="tg-sticky-container" style="height: 8vh;">
                        <div *ngIf="selectable" class="tg-ckb">

                        </div>
                        <div *ngFor="let cCol of customIcoColsStart" class="tg-custom-ico-cell">

                        </div>
                        <div *ngFor="let cCol of calculatedColsStart" class="tg-custom-ico-cell">

                        </div>
                    </div>
                    <!-- [style.width.%]="cellWidthPerc!" -->
                    <div [id]="'tg-f-col_' + c + '_' + gridConfiguration.name"
                        *ngFor="let col of gridFilters; let c=index; trackBy: trackByIndex"
                        class="tg-cell filter {{col.column}}" style="align-items: flex-end; height: 8vh;"
                        [class.sticky-column]="isSticky(c)" [style.left.px]="getStickyLeftPosition(c)" [ngClass]="{'tg-cell-auto-width' : autoWidth, 
                            'tg-cell-notvisible': col.visible == false, 'tg-cell-big': isCellBig(col.column!)}">
                        <div *ngIf="col.visible == true && col.filterVisible! && !isSpecialFilter(col.column!)"
                            class="tg-cell-visible" [ngClass]="{'cnt-uoms': hasUoms}">
                            <teiasoft-input *ngIf="col.filterType == 'string' || col.filterType == 'any[]'" [size]="'s'"
                                (onInput)="onInputChange($event, col.column!, col.filterType)"
                                [value]="col.initialValue" [labelText]="'grid.contains' | translate"
                                [clearValue]="clearFilters" style="width: 100%;"></teiasoft-input>

                            <teiasoft-input *ngIf="col.filterType == 'number'" [type]="col.filterType" [size]="'s'"
                                (onInput)="onInputChangeNumericRange($event, col.column!, col.filterType)"
                                [labelText]="'grid.equals' | translate" [clearValue]="clearFilters" style="width: 100%;"
                                [isMultiOperator]="true" [hasUoms]="true" [uomOptionList]="col.optionsList!"
                                [defaultQueryDirection]="'eq'"
                                (selectedUomChange)="selectedUomChange($event, col.column!)"></teiasoft-input>

                            <teiasoft-datetime *ngIf="col.filterType == 'date'" [size]="'s'"
                                (onChange)="onChangeData($event, col.column!)" [showQueryDirection]="true"
                                [defaultQueryDirection]="'eq'"
                                [clearValue]="clearFilters" [dateFormat]="dateFormat"
                                style="width:100%;margin-bottom: 0.4vh;"></teiasoft-datetime>

                            <teiasoft-select *ngIf="col.filterType == 'select'" [size]="'s'"
                                [optionsList]="col.optionsList!" [clearValue]="clearFilters"
                                (onSelected)="onSelectedBoolean($event, col.column!)" [filterVersion]="true"
                                [labelText]="'grid.equals' | translate" style="width: 100%"
                                [clearValue]="clearFilters"></teiasoft-select>
                        </div>
                        <div *ngIf="col.visible == true && col.filterVisible! && isSpecialFilter(col.column!)"
                            class="tg-cell-visible">
                            <!-- [labelText]="'grid.contains' | translate" -->
                            <teiasoft-select-options [inputValues]="filters" [colName]="col.column!"
                                [oDataFilterMaps]="oDataFilterMaps" [clearValue]="clearFilters"
                                [preselectedValues]="getSelectedSpecialFilterValues(col.column!)"
                                (onSelectedFilterOptions)="onSelectedFilterOptions($event, col.column!, col.filterType!)"
                                [clearValue]="clearFilters"></teiasoft-select-options>
                        </div>
                        <div *ngIf="col.visible == true && col.filterVisible == false" class="tg-cell-visible">
                            <!-- NO FILTER FOR THIS COLUMN -->
                        </div>
                    </div>
                    <!-- <app-teiasoft-odata-filters 
                            [gridName]="odataEntity" 
                            [gridConfiguration]="gridConfiguration"
                            [oDataFilters]="gridFilters" 
                            [clearFilters]="clearFilters" 
                            [dateFormat]="dateFormat"
                            [columnsWidth]="columnsWidth">
                        </app-teiasoft-odata-filters> -->
                    <div *ngFor="let cCol of calculatedColsEnd" class="tg-custom-ico-cell">
                    </div>
                    <div *ngFor="let cCol of customIcoColsEnd" class="tg-custom-ico-cell">

                    </div>
                    <div *ngIf="showEditIcon || showDeleteIcon" class="tg-custom-ico-cell">

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="teiasoftGrid" *ngIf="isLoaded && !anyGridError" class="teiasoft-grid" ><!-- [style.width.px]="gridW" -->
        <!-- GRID ROWS -->
        <div class="tg-body-cnt" [style.max-height.vh]="maxHeightVh">
            <div class="tg-row-ext" *ngFor="let row of pageDataSet; let i=index; trackBy: trackByIndex">
                <div class="tg-row-od"
                    [ngClass]="{'tg-row-alternate' : isEven(i), 'tg-row-selectable': (!selectable && !disableAllSelection), 
                    'tg-row-active' : (!selectable && !disableAllSelection) && (selectedIndex == i), 'cursor-pointer': enableDoubleClick,}"
                    (click)="onRowClick($event,row,i)" (dblclick)="onRowDoubleClick(row, i, 'expandRow|Items')">
                    <!-- <div class="cnt-ico-left" [ngClass]="{'cell-alternate': isEven(i),
                        'tg-row-active' : (!selectable && !disableAllSelection) && (selectedIndex == i)}"> -->
                    <div #oDataStickyContainer class="tg-sticky-container">
                        <div *ngIf="selectable && !disableAllSelection" class="tg-ckb">
                            <input id="ckb_{{i}}" type="checkbox" class="tg-ckb-input"
                                (click)="onChkSelectRowClick(row, i)">
                        </div>
                        <!-- CUSTOM ICO COLS START-->
                        <div *ngFor="let cCol of customIcoColsStart; let p = index; trackBy: trackByIndex" class="tg-custom-ico-cell">
                            <!-- CUSTOM ICON DISABLED -->
                            <i *ngIf="customIcoColDisabled(cCol, row) "
                                class="{{cCol.getIcon ? cCol.getIcon(row)[0] : cCol.icon![0]}} tg-custom-icon-disabled"
                                [title]="cCol.getTooltip ? cCol.getTooltip(row) : cCol.tooltip!"></i>
                            <!-- CUSTOM ICON GENERIC -->
                            <i *ngIf="!customIcoColDisabled(cCol, row) && (cCol.getIcon ? cCol.getIcon(row)[0] : cCol.icon![0]) != 'fal fa-ellipsis-h'"
                                [id]="'customIcon_' + oDataUrl + i + '_' + p"
                                class="{{cCol.getIcon ? cCol.getIcon(row)[0] : cCol.icon![0]}} tg-custom-icon"
                                [style.--tg-custom-icon-color]="getCustomIcoColColor(cCol, row)"
                                [title]="cCol.getTooltip ? cCol.getTooltip(row) : cCol.tooltip! | translate"
                                (click)="onCustomIcoClick($event, cCol, row, i, p)">
                            </i>

                            <!-- CUSTOM ICON ELLIPSIS FOR MENU -->
                            <i *ngIf="!customIcoColDisabled(cCol, row) && (cCol.getIcon ? cCol.getIcon(row)[0] : cCol.icon![0]) == 'fal fa-ellipsis-h'"
                                [id]="'customIcon_' + oDataUrl + i + '_' + p"
                                class="{{cCol.getIcon ? cCol.getIcon(row)[0] : cCol.icon![0]}} tg-custom-icon"
                                [style.--tg-custom-icon-color]="getCustomIcoColColor(cCol, row)"
                                [title]="cCol.getTooltip ? cCol.getTooltip(row) : cCol.tooltip! | translate"
                                (click)="onCustomIcoClick($event, cCol, row, i, p)" [matMenuTriggerFor]="menu">
                            </i>
                            <mat-menu #menu="matMenu">

                                <button *ngFor="let voice of cCol.menuVoices" mat-menu-item
                                    [disabled]="customMenuVoiceDisabled(voice.action!, row)"
                                    (click)="onMenuVoiceClick(voice.action!, row, 'context_' + i + '_' + p)"
                                    class="menu-voice-button">
                                    <i [ngClass]="voice.icon" class="menu-voice-ico"></i> {{voice.text! | translate}}
                                </button>
                            </mat-menu>

                            <!-- CONTEXT MENU -->
                            <!-- <div [id]="'context_' + i + '_' + p" class="tg-context-menu" style="display:none" (mouseleave)="onCloseMenuContext('context_' + i + '_' + p)">
                                <div *ngFor="let voice of cCol.menuVoices" class="tg-context-menu-voice" (click)="onMenuVoiceClick(voice.action!, row, 'context_' + i + '_' + p)"
                                    [ngClass]="{'tg-menu-voice-disabled': customMenuVoiceDisabled(voice.action!, row)}">
                                    <span style="margin-left: 0.5vw;">{{voice.text!}}</span>
                                </div>
                            </div> -->
                        </div>
                        <!-- CALCULATED COLS START-->
                        <div *ngFor="let ccCol of calculatedColsStart" class="tg-custom-ico-cell">
                            <i class="{{calculateCol(ccCol, row)}} tg-calc-icon"
                                [title]="row[ccCol.method!.split('|')[1]]"></i>
                            <!-- GBR 11/12/2023 - Rimosso temporanteamente [title]="ccCol.tooltip!" -->
                        </div>
                    </div>
                    <!-- DATA -->
                    <div *ngFor="let col of columnsGOD; let c=index; trackBy: trackByColumn" class="tg-cell {{col.name!}}" [ngClass]="{'tg-cell-auto-width' : autoWidth, 'tg-cell-notvisible': col.visible == false, 'tg-cell-big': isCellBig(col.name!), 
                         'cell-alternate':  isEven(i),
                        'tg-row-active' : (!selectable && !disableAllSelection) && (selectedIndex == i),
                        'clickable' : isColumnClickable(col,row)}" (click)="onCellClickOdatGrid(row, col.name!)"
                        [class.sticky-column]="isSticky(c)" [style.width.px]="col.width"
                        [style.left.px]="getStickyLeftPosition(c)">
                        <!-- [ngStyle]="{'background-color': getCellSpecialStyles(col, 'bgColor', i)}" -->
                        <div *ngIf="col.visible == true" class="tg-cell-visible">
                            <span *ngIf="col.type! == 'string' || col.type! == 'number' || col.type == 'any[]'"
                                class="tg-cell-value string">{{getColValue(row, col)}}</span>
                            <!-- TO REMOVE -->
                            <span
                                *ngIf="col.type! == 'date'"
                                class="tg-cell-value"
                                [ngClass]="getDateCssClass(col)">{{getDateDisplayValue(row, col) | date:getDateDisplayFormat(col)}}</span>
                            <span class="tg-cell-value string" *ngIf="col.type! == 'boolean'">{{geBooleanValue(row,
                                col)}}</span>
                        </div>
                    </div>
                    <!-- CALCULATED COLS START -->
                    <div *ngFor="let ccCol of calculatedColsEnd" class="tg-custom-ico-cell">
                        <i class="{{calculateCol(ccCol, row)}} tg-calc-icon" [title]="ccCol.tooltip!"></i>
                    </div>
                    <!-- CUSTOM ICO COLS END -->
                    <div *ngFor="let cCol of customIcoColsEnd; let p = index; trackBy: trackByIndex" class="tg-custom-ico-cell">
                        <i *ngIf="!cCol.disabled" [id]="'customIcon_' + oDataUrl + i + '_' + p"
                            class="{{cCol.getIcon ? cCol.getIcon(row)[0] : cCol.icon![0]}} tg-custom-icon"
                            [style.--tg-custom-icon-color]="getCustomIcoColColor(cCol, row)"
                            [title]="cCol.getTooltip ? cCol.getTooltip(row) : cCol.tooltip! | translate"
                            (click)="onCustomIcoClick($event, cCol, row, i, p)"></i>
                        <i *ngIf="cCol.disabled"
                            class="{{cCol.getIcon ? cCol.getIcon(row)[0] : cCol.icon![0]}} tg-custom-icon-disabled"
                            [title]="cCol.getTooltip ? cCol.getTooltip(row) : cCol.tooltip! | translate"></i>
                    </div>
                    <!-- EDIT/DELETE DEFAULT COLS -->
                    <div *ngIf="showEditIcon || showDeleteIcon" class="tg-cell align-right"
                        [style.width.%]="cellWidthPerc!">
                        <span *ngIf="showEditIcon" class="tg-cell-icon"
                            (click)="onEditClick($event, row)">&#x270E;</span>
                        <span *ngIf="showDeleteIcon" class="tg-cell-icon"
                            (click)="onDeleteClick($event, row)">&#10539;</span>
                    </div>
                </div>
                <!-- ROW EXPANDED - CONTAINS ANOTHER TABLE -->
                <div [id]="'expRow_'+ oDataUrl + i " class="tg-row-expanded" style="display:none">
                    <!-- [style.width.px]="rowExpandedWidth" -->
                    <span *ngIf="dataSetRow && dataSetRow.length == 0 && expandedEnquiryNo == row['EnquiryNo']"
                        class="tg-span-nodata ml-5">{{'grid.noItems' | translate}}</span>
                    <teiasoft-grid *ngIf="dataSetRow && dataSetRow.length > 0 && expandedEnquiryNo == row['EnquiryNo']"
                        [title]="'edit-enquiry-item'" [gridDescription]="getExpandedTableDescription()"
                        [gridDescriptionExtraTemplate]="expandedGridDescriptionExtraTemplate"
                        [gridDescriptionExtraContext]="expandedGridDescriptionExtraContext"
                        style="width:100%" [columnsToHide]="columnsToHideRow" [columnsToShow]="columnsToShowRow"
                        [dataSet]="dataSetRow" [showFooter]="false" [selectable]="false" [disableAllSelection]='false'
                        [theme]="theme" [autoWidth]="true" [showEditIcon]="false" [dateFormat]="dateFormat!"
                        [dateTimeFormat]="dateTimeFormat!" [sortable]="false" [calculatedCols]="calculatedCols"
                        (onCellClick)="cellClick($event)"
                        (customIconContextMenuClick)="onExpandedGridContextMenuClick($event, row)"
                        [roundDigitsItems]="roundDigitsItems" [enquiryNo]="row['EnquiryNo']" [showLoader]="false"
                        [salesOfficeId]="row['SalesOfficeId']" [origin]="origin"
                        [virtualScroll]="expandedGridVirtualScroll" [virtualScrollMinRows]="expandedGridVirtualScrollMinRows"
                        [customRenderers]="customRenderers" [customHeaderRenderers]="customHeaderRenderers" [enquiryHeader]="row"></teiasoft-grid>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- GRID FOOTER -->
<div class="tg-footer" *ngIf="showFooter && !anyGridError">
    <div class="tg-footer-pager">
        <span *ngIf="paginable && pageIndex == 1" class="tg-footer-span tg-link-arrow-disabled tg-sx"
            (click)="onClickPageBackToTop()">&#10094;&#10094;</span>
        <span *ngIf="paginable && pageIndex > 1" class="tg-footer-span tg-link-arrow tg-sx"
            (click)="onClickPageBackToTop()">&#10094;&#10094;</span>

        <span *ngIf="paginable && pageIndex > 1" class="tg-footer-span tg-link-arrow tg-sx"
            (click)="onClickPageBack()">&#10094;</span>
        <span *ngIf="paginable && pageIndex == 1" class="tg-footer-span tg-link-arrow-disabled tg-sx">&#10094;</span>

        <span *ngIf="paginable && dataSet.length >= rowsPerPage" class="tg-footer-span  tg-link-arrow tg-dx"
            (click)="onClickPageForward()">&#10095;</span>
        <span *ngIf="paginable && dataSet.length < rowsPerPage"
            class="tg-footer-span  tg-link-arrow-disabled tg-dx">&#10095;</span>
    </div>
    <div class="tg-footer-items">
        <!-- <span *ngIf="paginable" class="tg-footer-span span-margin">{{(((this.pageIndex-1)*this.rowsPerPage)+1)}} -
            {{getFooterCalcItems()}} {{'of' | translate}} </span> -->
        <span class="tg-footer-span">{{dataSet.length}} {{'commons.rows' | translate}}</span>
    </div>
</div>

<div *ngIf="anyGridError" class="tg-cnt-error">
    <i class="fa-regular fa-face-frown-open tg-ico-error"></i>
    <span *ngIf="!columnsGOD || columnsGOD.length == 0">{{'errors.entityStructureError' | translate}}:
        {{oDataUrl}}</span>
    <span *ngIf="columnsGOD && columnsGOD.length > 0">{{'errors.entityGenericError' | translate}}: {{oDataUrl}}</span>
</div>

<!-- PLACE HOLDER FOR LOADING -->
<div *ngIf="!isLoaded" class="tg-placeholder">
    <div class="tg-ico-loader">

    </div>
</div>

<!-- MODAL SETTINGS -->
<teiasoft-grid-settings *ngIf="showSettingsDialog" [gridConfiguration]="gridConfiguration"
    [columnDisabled]="columnToFixInSettings" (onClose)="onCloseSettings($event)" (onApply)="onApplySettings($event)"
    [disableFreezeFeature]="false"></teiasoft-grid-settings>
